import type { FaireProductEntity } from "../../entity_types/product";

export const p_ethmxkzw: FaireProductEntity = {
  token: "p_ethmxkzw",
  type: "product",
  name: "You Are My Person Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1eb9acbfc4b21a928b7b945231bb8627208b93f2ac4aef4336ee573fec53e3f7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/80cb14cbb63ae8bf688993e6d1496dfdf66f767a04a912cd23ae5de1c54c05eb/1528359530.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:15.694Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
